import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthStore } from '@auth';
import { NotificationSSEApi } from '@core/apis/notification-sse.api';
import { NotificationConnectModel } from '@shared/models/notification/notification-connect.model';
import { defer, filter, map, Observable, of, retry, share, switchMap, throwError, timer } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NotificationSSEStore {
  public constructor(
    private api: NotificationSSEApi,
    private authStore: AuthStore
  ) {}

  public readonly event$: Observable<NotificationConnectModel> = this.authStore.userProfile$.pipe(
    filter(Boolean),
    switchMap(() => this.#getNotificationEvent()),
    share()
  );

  #getNotificationEvent(): Observable<NotificationConnectModel> {
    return defer(() => this.api.connect()).pipe(
      retry({
        delay: (error: HttpErrorResponse) => {
          if (!error.status) {
            return timer(3000).pipe(tap(() => console.debug('Retrying to connect to SSE')));
          }
          return throwError(() => of(error));
        }
      }),
      map(e => e.notification)
    );
  }
}
